module.exports = __webpack_public_path__ + "img/04d.05923f96.svg";